import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async create_shit_templates(data) {
    let response = await apiCall("shit_templates/create", data);
    return response;
  },
  async list_shit_templates(data) {
    let response = await apiCall("shit_templates/list_shit_templates", data);
    return response;
  },
  async update_shit_templates(data) {
    let response = await apiCall(
      "shit_templates/update_fuel_station_group",
      data
    );
    return response;
  },
};
